import React from 'react'
import { connect } from 'react-redux'
import PresetActions from '../../Redux/PresetRedux'
import { currentBranch, currentCurrency } from '../../Utils/PrivilegeUtils' // deprecate after merge with PH
import FormatMoney from '../../Utils/FormatMoney'

class ProductPreset extends React.Component {
  constructor (props) {
    super(props)
    this.branch = currentBranch()
    this.currency = currentCurrency()
    this.state = {
      form: {
        COD: this.branch === 'PH' ? props.preset.dataBranch[this.branch].COD : '',
        general_discount_extend_wifi: props.preset.dataPresetOrder.general_discount_extend_wifi,
        deposit: '', // still needed for placeholder
        country: this.branch,
        deposit_country: props.preset.dataPresetOrder.deposit_country[this.branch].deposit,
        currency_code: currentCurrency()
      },
      editMode: null,
      forceEditMode: false
    }
  }

  _inputChange = (event, field) => {
    let form = { ...this.state.form }
    let value = event.target.value
    form[field] = value
    this.setState({ form })
  }

  _editMode = (forceEditMode, field, value) => {
    let form = { ...this.state.form }
    form[field] = value
    this.setState({
      editMode: field,
      forceEditMode,
      form
    })
  }

  _submit = (field) => {
    let data = {}
    if (field === 'deposit') {
      data = {
        country: this.state.form.country,
        deposit_country: this.state.form.deposit,
        currency_code: this.state.form.currency_code
      }
    } else if (field === 'general_discount_extend_wifi') {
      data = {
        general_discount_extend_wifi: this.state.form.general_discount_extend_wifi
      }
    } else if (field === 'COD') {
      data = {
        country: this.state.form.country,
        product: field,
        value: this.state.form.COD
      }
    }

    if (field === 'COD') {
      this.props.updateBranch(data)
    } else {
      this.props.submit(data)
    }
    setTimeout(() => {
      this._editMode(false)
    }, 500)
  }

  _renderRow = (data, field, title) => {
    return (
      <tr>
        <td className='text-center'>{title}</td>
        {
          this.state.editMode === field
            ? <td className='text-center'>
              <div className='input-group'>
                <input
                  className='form-control my-0'
                  type={field === 'COD' ? 'text' : 'number'}
                  min={field === 'general_discount_extend_wifi' ? 0 : null}
                  max={field === 'general_discount_extend_wifi' ? 100 : null}
                  value={this.state.form[field]}
                  onChange={(event) => this._inputChange(event, field)}
                />
                <div className='input-group-append'>
                  <button className='btn btn-primary mb-0' onClick={() => this._submit(field)}>Submit</button>
                </div>
              </div>
            </td>
            : <td className='text-center'>
              {
                field === 'deposit'
                  ? `${FormatMoney(data[field])}`
                  : field === 'general_discount_extend_wifi'
                    ? `${data[field]} %`
                    : data[field]
              }
            </td>
        }
        {
          this.state.editMode === field
            ? <td className='text-center'>
              <button className='btn btn-danger' onClick={() => this._editMode(false)}>
                <i className='fa fa-times' />
              </button>
            </td>
            : <td className='text-center'>
              <button disabled={this.state.forceEditMode} className={`btn btn-primary ${this.state.forceEditMode ? 'btn-disabled' : ''}`} onClick={() => this._editMode(true, field, data[field])}>
                <i className='fa fa-edit' />
              </button>
            </td>
        }
      </tr>
    )
  }

  componentDidMount = () => {
    this.props.get()
  }

  render () {
    const { preset } = this.props
    const { dataPresetOrder, dataBranch } = preset
    return (
      <section className='section'>
        <div className='card'>
          <table className='table table-hover table-striped'>
            <thead>
              <tr>
                <th className='text-center'>Preset Name</th>
                <th className='text-center'>Preset Value</th>
                <th className='text-center'>Preset Edit</th>
              </tr>
            </thead>
            <tbody>
              { this.branch === 'ID' && this._renderRow(dataPresetOrder, 'general_discount_extend_wifi', 'Extend Wifi Discount') }
              { this._renderRow(dataPresetOrder.deposit_country[this.branch], 'deposit', 'Deposit') }
              { this.branch === 'PH' && this._renderRow(dataBranch[this.branch], 'COD', 'COD Payment Text') }
            </tbody>
          </table>
        </div>
      </section>
    )
  }
}

const stateToProps = (state) => ({
  preset: state.preset
})

const dispatchToProps = (dispatch) => ({
  get: () => dispatch(PresetActions.presetOrderRequest()),
  submit: (data) => dispatch(PresetActions.presetOrderUpdateRequest(data)),
  updateBranch: (data) => dispatch(PresetActions.updateBranchRequest(data))
})

export default connect(stateToProps, dispatchToProps)(ProductPreset)



// WEBPACK FOOTER //
// ./src/Containers/Product/ProductPreset.js